// API
import { navigation } from 'api/docset'

// Types
import { Navigation } from 'types/navigation'

export function getNavigation(alias: string, cfr: string, id: string): Promise<Navigation> {
  return navigation(alias, cfr, id)
}